const deleteItemByPlayer = (openModal, type, itemId, playerId, optionWeekId) => {
  openModal('modal-confirm-trash', {
    itemId,
    type,
    playerId,
    optionWeekId: optionWeekId || null,
  });
};

const deleteHosting = (openModal, type, hostingId) => {
  openModal('modal-confirm-trash', {
    type,
    hostingId,
  });
};

const triggerConfirmDelete = {
  deleteItemByPlayer,
  deleteHosting,
};

export default triggerConfirmDelete;
